import React, { useEffect } from 'react';

const AuthCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('access_token', token);

      import('../../utils/auth').then(auth => {
        auth.setToken(token);
        // ✅ Redirect to stored path or Home
        const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/Home';
        sessionStorage.removeItem('redirectAfterLogin');
        window.location.href = redirectPath;
      });
    } else {
      window.location.replace('/Login');
    }
  }, []);

  return (
    <div className="login-bg-container">
      <div className="login-card">
        <h1 className="login-title">Signing you in...</h1>
        <p className="login-subtitle">Please wait while we finish authentication</p>
      </div>
    </div>
  );
};

export default AuthCallback;
